import Vue from "vue";
import Router from "vue-router";
import RiverInfo from "@/views/RiverInfo.vue";
import News from "@/views/News.vue";
import Complaint from "@/views/Complaint.vue";
import SearchNews from "@/views/SearchNews.vue";
import NewsDetail from "@/views/NewsDetail.vue";
import ComplaintSummary from "@/views/ComplaintSummary.vue";
import RiverList from "@/views/RiverList.vue";

Vue.use(Router);

export default new Router({
  mode: "hash",
  routes: [
    {
      path: "/",
      redirect: "/river",
    },
    {
      path: "/river",
      component: RiverInfo,
      meta: { keepAlive: true },
    },
    {
      path: "/news",
      component: News,
      meta: { keepAlive: true },
    },
    {
      path: "/search-news",
      component: SearchNews,
    },
    {
      path: "/complaint/:type/:value",
      name: "Complaint",
      component: Complaint,
      meta: {
        hideTabBar: true,
      },
    },
    {
      path: "/profile",
      name: "Profile",
      component: () => import("@/views/Profile.vue"),
      exact: true,
      meta: { requiresAuth: true, keepAlive: true },
    },
    {
      path: "/patrol-areas",
      name: "PatrolAreas",
      component: () => import("@/views/PatrolAreas.vue"),
      meta: {
        requiresAuth: true,
        hideTabBar: true,
      },
    },
    {
      path: "/patrol-stats",
      name: "PatrolStats",
      component: () => import("@/views/PatrolStats.vue"),
      meta: {
        requiresAuth: true,
        hideTabBar: true,
      },
    },
    {
      path: "/patrol-record/:id",
      name: "PatrolRecordDetail",
      component: () => import("@/views/PatrolRecordDetail.vue"),
      meta: {
        requiresAuth: true,
        hideTabBar: true,
      },
    },
    {
      path: "/river-patrol",
      name: "RiverPatrol",
      component: () => import("@/views/RiverPatrol.vue"),
      meta: {
        requiresAuth: true,
        hideTabBar: true,
      },
    },
    {
      path: "/lake-patrol",
      name: "LakePatrol",
      component: () => import("@/views/LakePatrol.vue"),
      meta: {
        requiresAuth: true,
        hideTabBar: true,
      },
    },
    {
      path: "/new-patrol",
      name: "NewPatrol",
      component: () => import("@/views/NewPatrol.vue"),
      meta: {
        requiresAuth: true,
        hideTabBar: true,
      },
    },
    {
      path: "/new-lake-patrol",
      name: "NewLakePatrol",
      component: () => import("@/views/NewLakePatrol.vue"),
      meta: {
        requiresAuth: true,
        hideTabBar: true,
      },
    },
    {
      path: "/news-detail",
      name: "NewsDetail",
      component: NewsDetail,
    },
    {
      path: "*",
      redirect: "/river",
    },
    {
      path: "/complaint-summary",
      name: "ComplaintSummary",
      component: ComplaintSummary,
      meta: { keepAlive: true },
    },
    {
      path: "/river-list",
      component: RiverList,
    },
    {
      path: "/complaint-suggestion-list",
      name: "ComplaintSuggestionList",
      component: () => import("@/views/ComplaintSuggestionList.vue"),
      meta: {
        requiresAuth: true,
        keepAlive: false,
        hideTabBar: true,
      },
    },
    {
      path: "/complaint-suggestion-detail/:id/:activeTab/:geospatialTypeText",
      name: "ComplaintSuggestionDetail",
      component: () => import("@/views/ComplaintSuggestionDetail.vue"),
      meta: {
        requiresAuth: true,
        hideTabBar: true,
      },
    },
    {
      path: "/water-quality-all",
      name: "WaterQualityAll",
      component: () => import("@/views/WaterQualityAll.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/river-detail/:id",
      name: "RiverDetail",
      component: () => import("@/views/RiverDetail.vue"),
      meta: {
        requiresAuth: true,
        hideTabBar: true,
      },
    },
    {
      path: "/report-issue",
      name: "ReportIssue",
      component: () => import("@/views/ReportIssue.vue"),
      meta: {
        requiresAuth: true,
        hideTabBar: true,
      },
    },
    {
      path: "/problem-report",
      name: "ProblemReport",
      component: () => import("@/views/ProblemReport.vue"),
      meta: {
        requiresAuth: true,
        hideTabBar: true,
      },
    },
    {
      path: "/problem-report-detail",
      name: "ProblemReportDetail",
      component: () => import("@/views/ProblemReportDetail.vue"),
      meta: {
        requiresAuth: true,
        hideTabBar: true,
      },
    },
    {
      path: "/new-problem-report",
      name: "NewProblemReport",
      component: () => import("@/views/NewProblemReport.vue"),
      meta: {
        requiresAuth: true,
        hideTabBar: true,
      },
    },
    {
      path: "/inspection-checklist",
      name: "InspectionChecklist",
      component: () => import("@/views/InspectionChecklist.vue"),
      meta: {
        requiresAuth: true,
        hideTabBar: true,
      },
    },
    {
      path: "/inspection-check-detail",
      name: "InspectionCheckDetail",
      component: () => import("@/views/InspectionCheckDetail.vue"),
      meta: {
        requiresAuth: true,
        hideTabBar: true,
      },
    },
    {
      path: "/inspection-history",
      name: "InspectionHistory",
      component: () => import("@/views/InspectionHistory.vue"),
      meta: {
        requiresAuth: true,
        hideTabBar: true,
      },
    },
    {
      path: "/complaint-list",
      name: "ComplaintList",
      component: () => import("@/views/ComplaintList.vue"),
      meta: {
        requiresAuth: true,
        hideTabBar: true,
      },
    },
    {
      path: "/problem-stats",
      name: "ProblemStats",
      component: () => import("@/views/ProblemStats.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/responsible-unit-feedback",
      name: "ResponsibleUnitFeedbackList",
      component: () => import("@/views/ResponsibleUnitFeedbackList.vue"),
      meta: {
        requiresAuth: true,
        hideTabBar: true,
      },
    },
    {
      path: "/responsible-unit-feedback-detail",
      name: "ResponsibleUnitFeedbackDetail",
      component: () => import("@/views/ResponsibleUnitFeedbackDetail.vue"),
      meta: {
        requiresAuth: true,
        hideTabBar: true,
      },
    },
    {
      path: "/responsible-person-feedback",
      name: "ResponsiblePersonFeedbackList",
      component: () => import("@/views/ResponsiblePersonFeedbackList.vue"),
      meta: {
        requiresAuth: true,
        hideTabBar: true,
      },
    },
    {
      path: "/responsible-person-feedback-detail",
      name: "ResponsiblePersonFeedbackDetail",
      component: () => import("@/views/ResponsiblePersonFeedbackDetail.vue"),
      meta: {
        requiresAuth: true,
        hideTabBar: true,
      },
    },
    {
      path: "/history-detail",
      name: "HistoryDetail",
      component: () => import("@/views/HistoryDetail.vue"),
      meta: {
        requiresAuth: true,
        hideTabBar: true,
      },
    },
    {
      path: "/history-list",
      name: "HistoryList",
      component: () => import("@/views/HistoryList.vue"),
      meta: {
        requiresAuth: true,
        hideTabBar: true,
      },
    },
    {
      path: "/water-quality-categories",
      name: "WaterQualityCategories",
      component: () => import("@/views/WaterQualityCategories.vue"),
      meta: {
        hideTabBar: true,
      },
    },
    {
      path: "/river-location/:id",
      name: "RiverLocation",
      component: () => import("@/views/RiverLocation.vue"),
      meta: {
        requiresAuth: true,
        hideTabBar: true,
      },
    },
    {
      path: "/patrol-trajectory/:id",
      name: "PatrolTrajectory",
      component: () => import("@/views/PatrolTrajectory.vue"),
      meta: {
        requiresAuth: true,
        hideTabBar: true,
      },
    },
  ],
});
